import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../../js/api/axios";

export const fetchColourPalette = async (colourCode) => {
  const response = await axiosInstance.get(
    `/colourWheelApi/getColourPalette/?colourCode=${colourCode}`
  );
  return response.data;
};

export const useColourPalette = (colourCode) => {
  return useQuery({
    queryKey: ["colour-palette", colourCode],
    queryFn: () => fetchColourPalette(colourCode),
    enabled: !!colourCode,
  });
};
